import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const stockKey = (productId, size, colour) =>
  `${productId}|${size}|${colour}`;

// Returns { stock: Map<key, qty> | null (loading), refresh }
export const useInventory = () => {
  const [stock, setStock] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/inventory`);
      setStock(
        new Map(
          data.map((s) => [stockKey(s.product_id, s.size, s.colour), s.qty]),
        ),
      );
    } catch {
      setStock(new Map());
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { stock, refresh };
};

export const productInStock = (stock, productId) => {
  if (!stock) return true;
  for (const [key, qty] of stock) {
    if (key.startsWith(`${productId}|`) && qty > 0) return true;
  }
  return false;
};
